import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import cx from 'classnames';
import { Button, UncontrolledTooltip } from 'reactstrap';

export default function PageTitle(props) {
  const { 
    heading, 
    icon, 
    subheading, 
    buttonLabel, 
    buttonTooltip, 
    buttonLink, 
    customButton, 
    customButtonLabel, 
    customButtonClick,
    customButtonTooltip,
    externalButtonLabel,
    externalButtonLink
  } = props;
  const history = useHistory();

  const onSubmit = useCallback(async () => {
    if (buttonLink) {
      history.replace(buttonLink);
    }
  }, [history, buttonLink]);

  return (
    <div className="app-page-title">
      <div className="page-title-wrapper">
        <div className="page-title-heading">
          <div
            className={cx('page-title-icon rounded-circle', {
              'd-none': false,
            })}
          >
            <i className={icon} />
          </div>
          <div>
            {heading}
            <div
              className={cx('page-title-subheading', {
                'd-none': false,
              })}
            >
              {subheading}
            </div>
          </div>
        </div>

        {externalButtonLabel && externalButtonLink && (
          <div className="page-title-actions">
            <a
              className='btn btn-primary mb-2 mr-2'
              href={externalButtonLink}
              target='_blank'
              rel='noreferrer noopener'
            >
              {externalButtonLabel}
            </a>
          </div>
        )}

        {buttonLabel && buttonLink && (
          <div className="page-title-actions">
            <Button
              className="mb-2 mr-2"
              color="primary"
              onClick={onSubmit}
              id="pageTitleButton"
            >
              {buttonLabel}
            </Button>
            <UncontrolledTooltip
              placement="left"
              target={'pageTitleButton'}
            >
              {buttonTooltip}
            </UncontrolledTooltip>
          </div>
        )}

        {customButton && (
          <div className="page-title-actions">
            <Button
              className="mb-2 mr-2"
              color="primary"
              onClick={customButtonClick}
              id="pageTitleButton"
            >
              {customButtonLabel}
            </Button>
            <UncontrolledTooltip
              placement="left"
              target={'pageTitleButton'}
            >
              {customButtonTooltip}
            </UncontrolledTooltip>
          </div>
        )}
      </div>
    </div>
  );
}
